module.exports = __webpack_public_path__ + "img/equipProcess.f2c190d6.png";